const PropertyRolesEnum = {
  ROOM: 'ROOM',
  UNIT: 'UNIT',
  SINGLE_UNIT: 'SINGLE_UNIT',
  MULTI_UNIT: 'MULTI_UNIT',
};

export default PropertyRolesEnum;
